import React from 'react'; 
import { CgCPlusPlus } from "react-icons/cg";
//import { CgC } from 'react-icons/cg';
import { FaHtml5 } from "react-icons/fa";
import { DiCss3 } from "react-icons/di";

import { FaReact, FaPython, FaGitAlt, FaGithub, FaDocker, FaJava, FaAws, FaAngular } from "react-icons/fa";
import { DiNodejs, DiJavascript1 } from "react-icons/di";
import { BsDatabase } from "react-icons/bs";
import { 
  SiExpress, SiMongodb, SiVercel, SiTypescript, SiGo, SiNextdotjs, SiTailwindcss,
  SiFirebase, SiPostgresql, SiMysql, SiSqlite, SiGithubactions, SiTensorflow, SiKeras,
  SiScikitlearn, SiPandas, SiNumpy, SiRedis, SiFastapi, SiFlask, SiWebassembly, SiFigma
} from "react-icons/si";
import { SiPostman } from "react-icons/si";

const Skills = ({skill}) => {
    const icon = {
        'C++': <CgCPlusPlus/>,
        //'C': <CgCColor/>,
        Python: <FaPython/>,
        Java: <FaJava/>,
        JavaScript: <DiJavascript1/>,
        'TypeScript': <SiTypescript/>,
        Go: <SiGo/>,
        SQL: <BsDatabase/>,

        HTML: <FaHtml5/>,
        CSS: <DiCss3/>,

        React: <FaReact/>,
        'Next.js': <SiNextdotjs/>,
        'Node.js' : <DiNodejs/>,
        Express : <SiExpress/>,
        FastAPI: <SiFastapi/>,
        Flask: <SiFlask/>,
        Angular: <FaAngular/>,
        'Tailwind CSS': <SiTailwindcss/>,

        TensorFlow: <SiTensorflow/>,
        Keras: <SiKeras/>,
        'scikit-learn': <SiScikitlearn/>,
        pandas: <SiPandas/>,
        NumPy: <SiNumpy/>,

        PostgreSQL: <SiPostgresql/>,
        MongoDB : <SiMongodb/>,
        MySQL: <SiMysql/>,
        SQLite: <SiSqlite/>,

        AWS: <FaAws/>,
        Docker: <FaDocker/>,
        Git : <FaGitAlt/>,
        GitHub : <FaGithub/>,
        'GitHub Actions': <SiGithubactions/>,
        Redis: <SiRedis/>,
        Firebase: <SiFirebase/>,
        Figma : <SiFigma/>,
        WebAssembly: <SiWebassembly/>,
        Postman: <SiPostman />,
        Vercel: <SiVercel/>
    }
    
  return (
    <div title={skill} className='SkillBox'>
      {icon[skill]}
    </div>
  )
}

export default Skills
